
import simple from './simple';
import pro from './pro';
import preview from './preview';

export default simple;
export const MarkdownPro = pro ;
export const MarkdownPreview = preview ;
